import React, { useState } from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { at } from 'lodash'
import { useField } from 'formik'

export default function PhoneFieldIcon( { required, noPadding, disabled = false, question = "", name, label, handleChange, handleBlur, value, callback } ) {
    const [ field, meta ] = useField( name )
    const [ phoneNumber, setPhoneNumber ] = useState( "" )

    const _renderText = () => {
        const [ touched, error ] = at( meta, 'touched', 'error' )
        if( touched && error ) {
            return error
        }
    }
    return (
        <div className="flex flex-col items-start justify-center my-2">
            <p className="text-gray-700 py-1 text-xs">
             {question}{ required && ( <span className="text-red-500">*</span>) }
            </p>
            <PhoneInput 
                country={'ug'}
                placeholder="Phone Number"
                value={phoneNumber || value}
                onChange={( value, country, evt ) => {
                    if( country.name === "Uganda" ) {
                        callback( value )
                        setPhoneNumber( value )
                    }
                    else {
                        //alert( "Please choose Uganda Country code" )
                        callback( value )
                        setPhoneNumber( value )
                    }
                }}
                onBlur={handleBlur}
                inputProps={{
                    name,
                    id: name,
                    required: true,
                    autoFocus: true
                }}
                countryCodeEditable={false}
                inputStyle={{ width: "100%", border: "1px solid #8CADFB", borderRadius: "2px", fontFamily: "WSRegular" }}
                containerClass="inline-flex"
            />
            {/* <p className="text-gray-700 py-1 text-sm">
             {question}{ required && ( <span className="text-red-500">*</span>) }
            </p> */}
        </div>
    )
}